import effectManager from '../module/effect';

export default class topManager {
    constructor(effect) {

        this.effect = effect;

        this.$header;
        this.$headerContent;

        this.$kv;
        this.$copy1;
        this.$copy2;
        this.$sub;
        this.$bg;
        this.$content;

        this.kvH;


    }
    init(){

        this.$header = document.getElementById("l-header");
        this.$headerContent = document.getElementById("l-header-content");

        this.$kv = document.getElementById("p-kv");
        this.$title = document.querySelectorAll("#p-kv__title>*>*");
        this.$cover1 = document.querySelectorAll("#p-kv__title .kv-cover")[0];
        this.$cover2 = document.querySelectorAll("#p-kv__title .kv-cover")[1];
        this.$sub = document.querySelector("#p-kv .sub-title");
        this.$bg = document.getElementById("p-kv-bg");
        this.$content = document.getElementById("p-compare__detail");

        TweenMax.set([this.$title[0],this.$title[1]],{
            y:'100%'
        });
        TweenMax.set(this.$sub ,{
            css:{
                'letter-spacing':'-1em',
            }
        });

        TweenMax.to(this.$bg, 1 ,{
            delay: 1,
            x:'-100%',
            ease: Power3.easeOut,
            onComplete:() => {
                TweenMax.fromTo(this.$headerContent, .7, {
                    y: -80,
                },{
                    opacity: 1,
                    y: 0,
                    ease: Power3.easeOut,
                });
                TweenMax.fromTo(this.$content, 0.7 , {
                    y:30,
                    opacity: 0,
                },{

                    y: 0,
                    opacity: 1,
                    ease: Power3.easeOut,
                    onComplete:() => {
                        this.$content.style.transform = '';
                    }
                });
            }
        });

        if(window.innerWidth < 750){
            TweenMax.to(this.$sub, 0.8 ,{
                delay: 0.9,
                css:{
                    'letter-spacing':'-0.10em',
                },
                ease: Power2.easeOut
            });
        }else{
            TweenMax.to(this.$sub, 0.8 ,{
                delay: 0.9,
                css:{
                    'letter-spacing':'-0.09em',
                },
                ease: Power1.easeOut
            });
        }
        TweenMax.staggerTo(this.$title, .6 ,{
            delay: 1.4,
            y:'0%',
            ease: Power2.easeOut
        },0.08);

    }
    render(mouse,scrollInc){
    }
    scroll(_y){

        if(_y > this.kvH){
            this.$header.classList.add('is-fixed');
        }else{
            this.$header.classList.remove('is-fixed');
        }

    }
    resize(w,h){

        this.kvH = this.$kv.clientHeight;

    }
}